/**
 * Storage specifically for impersonation sessions.
 * Uses sessionStorage to scope impersonation to the current browser session.
 *
 * Behavior:
 * - Token preserved on page refresh
 * - Token inherited by tabs opened via links (target="_blank")
 * - Token NOT available in manually opened new tabs
 * - Token cleared when tab is closed
 */

const IMPERSONATION_TOKEN_KEY = 'access_token';

export function getImpersonationToken(): string | null {
  return sessionStorage.getItem(IMPERSONATION_TOKEN_KEY);
}

/**
 * Check if the user is currently impersonating.
 * Impersonation is determined by the presence of an impersonation token in sessionStorage.
 */
export function isImpersonating(): boolean {
  return sessionStorage.getItem(IMPERSONATION_TOKEN_KEY) !== null;
}

export function setImpersonationToken(token: string): void {
  sessionStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
}

export function clearImpersonation(): void {
  sessionStorage.removeItem(IMPERSONATION_TOKEN_KEY);
}
